
import Dot from '@/components/UntitledUI/Dot.vue'

export default {
    name: 'Suggestion',
    components: { Dot },
    props: {
        suggestion: {
            type: Object,
            required: true
        },
        isLoading: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        href () {
            if (this.suggestion.type === 'file') {
                return this.localePath(`/File/${this.suggestion.id}`) + '-' + this.$helpers.slugify(this.suggestion.title)
            }
            if (this.suggestion.type === 'contract') {
                return this.localePath(`/Contract-Template/${this.suggestion.id}`)
            }
            return null
        }
    }
}
